import styled from "styled-components";
import { Colors } from "../models/theme";

interface ChipProps {
  color: keyof Colors;
  size?: "sm" | "md" | "lg";
}

export const StyledChip = styled.div<ChipProps>`
  display: inline-block;
  background-color: ${({ theme, color }) => theme.colors[color]};
  font-weight: 700;
  padding: 0.4rem 1.3rem;
  border-radius: 100px;
`;

export const Chip: React.FC<ChipProps> = (props) => {
  return <StyledChip {...props}>{props.children}</StyledChip>;
};

// ${switchProp(prop("size", "md"), {
//   sm: css`
//     font-size: 1.4rem;
//     line-height: 1.4rem;
//   `,
//   md: css`
//     font-size: 1.8rem;
//     line-height: 1.8rem;
//   `,
//   lg: css`
//     font-size: 3.2rem;
//     line-height: 4rem;
//   `,
// })};
